import React, { useEffect } from 'react';
import { Box, Flex, Image, Link, Text, Tooltip } from '@chakra-ui/react';
import { Cartridge } from '../../../components/GamesList/cartridge';
import { useNavigate } from 'react-router-dom';
import { ethers } from 'ethers';
import { IGame } from '../../../providers/Games/useGames';
import { IGameToken } from '../../User/user';
import { formatUsd } from '../../../utils/parser';

export const Game = ({ data }: { data: IGame & IGameToken }) => {
	const history = useNavigate();

	const navigate = () => {
		history(`/game/${data.address}`);
	};

	const today = new Date();
	const twoWeeksBefore = new Date(today.setDate(today.getDate() - 21));
	const createDate = new Date(data.createdAt);
	const isNew = createDate > twoWeeksBefore;

	return (
		<Link
			textDecoration="none !important"
			display="flex"
			cursor="pointer"
			flexDirection="column"
			gridGap="16px"
			onClick={navigate}
			width="180px"
			position="relative"
			overflow="visible"
		>
			{isNew && (
				<Flex
					position="absolute"
					top="-10px"
					left="-3px"
					borderRadius="4px"
					p="4px 10px"
					fontSize="10px"
					fontWeight="600"
					bgColor="textSecondary"
					overflow="visible"
				>
					PREMIERE
				</Flex>
			)}
			<Image
				width="180px"
				height="240px"
				src={data.media.banner}
				objectFit="cover"
				userSelect="none"
			/>
			<Flex
				paddingX="4px"
				flexDirection="column"
				gridGap="16px"
			>
				<Tooltip
					label={data.name}
					placement="bottom-start"
				>
					<Text
						fontSize="14px"
						lineHeight="18px"
						textOverflow="ellipsis"
						whiteSpace="nowrap"
						overflow="hidden"
					>
						{data.name}
					</Text>
				</Tooltip>
				<Flex
					justifyContent="space-between"
					alignItems="center"
				>
					<Cartridge
						type={data.color.toUpperCase()}
						symbol={data.symbol}
						fontSize="12px"
						lineHeight="15px"
						padding="2px 6px"
						fontWeight="400"
						borderRadius="2px"
					/>
					<Box
						fontWeight="600"
						fontSize="12px"
						lineHeight="14px"
					>
						<>
							{data.marketplaceFee && (
								<Tooltip label="This indicates how much of sale goes to owner of marketplace that sell this game">
									<Box
										display="inline-block"
										color="gray"
										fontSize="10px"
										mr="5px"
									>
										Fee: {data.marketplaceFee}%
									</Box>
								</Tooltip>
							)}
							{data.balance
								? `x${Math.floor(Number(data.balance) * 100) / 100}`
								: formatUsd(ethers.utils.formatUnits(data.price, 4))}
						</>
					</Box>
				</Flex>
			</Flex>
		</Link>
	);
};
